export default {
  allowAlignment: false,
  attributeInserter: false,
  allowMediaInserter: false,
  allowCode: false,
  autoFocusBottomRight: true,
  markdownLinks: false,
  allowButton: false,
  allowEmoji: true,
  allowVideo: false,
  allowSocial: false,
  allowHtml: false
};